// removed by extract-text-webpack-plugin
module.exports = {"vpHide":"vpHide___19aDV","vpQuestionTitle":"vpQuestionTitle___3BqCQ","vpQuestionDescription":"vpQuestionDescription___eQ38O","vpTogglePreview":"vpTogglePreview___14tX7","vpQuestionSeparator":"vpQuestionSeparator___IjG39","vpRequiredLabel":"vpRequiredLabel___3RQrH","vpCursorPointer":"vpCursorPointer___wtEsb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/FullQuestion.module.less
// module id = 3513
// module chunks = 33